export const findImageIndexWithDefault = (
  images: string[],
  selectedImage?: string
) => {
  const index = images.findIndex(image => image === selectedImage)
  return index === -1 ? 0 : index
}
